import { useFormState } from 'react-hook-form'

export type ValidationState = true | string | undefined

/** Returns an error string if the field has failed validation.
 *  If no error, returns true if the field was touched, otherwise returns undefined.
 */
export const useValidationState = (fieldName: string): ValidationState => {
  const { errors, touchedFields } = useFormState({ name: fieldName })

  const touched = !!touchedFields[fieldName]

  const validationError = errors[fieldName]?.message as string | undefined

  return validationError ?? (touched ? true : undefined)
}
